import { useState, useEffect } from "react";

export const ConfirmButton = ({ onConfirm, children, confirmLabel = "Sure? Click again", className = "", confirmClassName = "", disabled, testId }) => {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const t = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(t);
  }, [armed]);
  return (
    <button
      type="button"
      disabled={disabled}
      data-testid={testId}
      data-armed={armed ? "true" : "false"}
      onClick={() => {
        if (armed) {
          setArmed(false);
          onConfirm();
        } else {
          setArmed(true);
        }
      }}
      className={armed ? confirmClassName || className : className}
    >
      {armed ? confirmLabel : children}
    </button>
  );
};
